import * as React from 'react';
import { withOnlyCurrentItem } from '../../decorators/selectors';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { WithItemCache, IItemCacheStateProps } from '../../withItemCache/WithItemCache';
import { uploadDefaultDropActionHandler } from './handlers/upload';
import { defaultDropActionControl } from '../../../controls/defaultDropActionControl';
import { IActionInput, renderAction } from '../../withAction/WithAction';
import { Action } from '../../action/Action';

/**
 * @public
 */
export interface IDefaultDropActionHandlerProps {
    itemKey: string;
}

/**
 * @public
 */
export interface IDefaultDropActionHandler {
    key: string;
    evaluate(itemCache: IItemCache, props: IDefaultDropActionHandlerProps): {
        action?: IActionInput;
    };
}

const HANDLERS: IDefaultDropActionHandler[] = [uploadDefaultDropActionHandler];

/**
 * @public
 */
export interface IItemDefaultDropActionProps {
    itemKey: string | undefined;
}

/**
 * Component which provides a 'defualt drop' action for an item, which is typically Upload.
 * @public
 */
export class ItemDefaultDropAction extends React.PureComponent<IItemDefaultDropActionProps> {
    public render(): JSX.Element {
        const {
            itemKey
        } = this.props;

        return (
            <WithItemCache>{ ({ itemCache }: IItemCacheStateProps) => {
                if (!itemKey) {
                    return (
                        <Action />
                    );
                }

                const controlHandler = itemCache.demandItemFacet(defaultDropActionControl, itemKey);

                const {
                    handlers
                } = defaultDropActionControl.evaluate(controlHandler)(itemCache, {
                    itemKey: itemKey,
                    handlers: HANDLERS
                });

                let HandlerAction: IActionInput | undefined;

                for (const handler of handlers) {
                    const {
                        action: handlerAction
                    } = handler.evaluate(itemCache, {
                        itemKey: itemKey
                    });

                    if (handlerAction) {
                        HandlerAction = handlerAction;
                        break;
                    }
                }

                return renderAction(HandlerAction);
            } }</WithItemCache>
        );
    }
}

/**
 * @public
 */
export const DefaultDropAction = withOnlyCurrentItem()(ItemDefaultDropAction);
